import React from 'react';
import PropTypes from 'prop-types';
import breakpoints from '@fuww/library/src/Theme/breakpoints';
import SpacingContainer from '@fuww/library/src/SpacingContainer';
import CardWithLink from '../../../CardWithLink';
import withQuery from '../../../../lib/withQuery';

const MoreNewsCard = ({
  data, variables, showCreatedAt,
}) => {
  const newsArticle = data.universalNewsArticles[0];

  return newsArticle ? (
    <>
      <CardWithLink
        key={newsArticle.title}
        newsArticle={newsArticle}
        variables={variables}
        sizes={`
          (min-width: 1440px) 318px,
          (min-width: ${breakpoints.lg}px) 23vw,
          (min-width: ${breakpoints.sm}px) 47vw,
          100vw
        `}
        showCreatedAt={showCreatedAt}
      />
      <SpacingContainer />
    </>
  ) : null;
};

MoreNewsCard.propTypes = {
  data: PropTypes.shape({
    universalNewsArticles: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string.isRequired,
    })).isRequired,
  }),
  variables: PropTypes.shape({}).isRequired,
  showCreatedAt: PropTypes.bool,
};

MoreNewsCard.defaultProps = {
  data: {},
  showCreatedAt: false,
};

const MoreNewsCardWithQuery = withQuery(MoreNewsCard);

export default MoreNewsCardWithQuery;
